// import { useNavigate } from 'react-router-dom'
// import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { type EventInfo } from '~/features/home/apis/mainInfo'
// import Button from '~/shared/components/buttons/Button'
import useViewport from '~/shared/hooks/useViewport'
// import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'
import useCountdown from '~/shared/utils/useCountdown'

interface Props {
  ongoingEvent: EventInfo
}

function MainIntro({ ongoingEvent }: Props) {
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium

  // const navigate = useNavigate()

  const Bg = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-1920-bg-home-intro.webp`
  const BgMobile = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-390-bg-home-intro.webp`
  const backgroundSrc = isMobile ? BgMobile : Bg

  // const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)

  return (
    <Wrapper>
      <ContentBox>
        <LogoBox>
          <Logo src={ongoingEvent.image_info.url} />
        </LogoBox>
        <TitleBox>
          <Title>{ongoingEvent.show_date}</Title>
          <Title>{ongoingEvent.place}</Title>
        </TitleBox>
        <CountdownBox>
          <CountdownTimeCircle>
            <CountdownTime>
              {useCountdown(ongoingEvent.start_date).days}
            </CountdownTime>
            <CountdownUnit>Days</CountdownUnit>
          </CountdownTimeCircle>
          <CountdownTimeCircle>
            <CountdownTime>
              {useCountdown(ongoingEvent.start_date).hours}
            </CountdownTime>
            <CountdownUnit>Hours</CountdownUnit>
          </CountdownTimeCircle>
          <CountdownTimeCircle>
            <CountdownTime>
              {useCountdown(ongoingEvent.start_date).minutes}
            </CountdownTime>
            <CountdownUnit>Min</CountdownUnit>
          </CountdownTimeCircle>
          <CountdownTimeCircle>
            <CountdownTime>
              {useCountdown(ongoingEvent.start_date).seconds}
            </CountdownTime>
            <CountdownUnit>Sec</CountdownUnit>
          </CountdownTimeCircle>
        </CountdownBox>
        {/* <ButtonBox>
          <Button
            $width={194}
            $height={58}
            $fontSize={18}
            $variant="mint"
            onClick={() => navigate('/general-participation/ticket')}
          >
            티켓 구매하기
          </Button>
          <Button
            $width={234}
            $height={58}
            $fontSize={18}
            $variant="pink"
            onClick={() =>
              setIsModalOpen({
                ...isModalOpen,
                contents: 'schedule',
                isOpen: true,
              })
            }
          >
            {ongoingEvent.start_date.slice(0, 4)} 스케줄보기
          </Button>
        </ButtonBox> */}
      </ContentBox>
      <Background src={backgroundSrc} alt="main background" />
    </Wrapper>
  )
}

export default MainIntro

const Wrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  aspect-ratio: 1920/1080;
  width: 100%;
  max-height: 1080px;

  @media ${theme.device.medium} {
    height: calc(100vh + 100px);
  }
`

const Background = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowDefault};
  top: 0;
  right: 0;
  left: 0;

  width: 100%;
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;

  object-fit: contain;

  /* @media ${theme.device.large} {
    gap: 12px;
    align-items: flex-start;
    width: 70%;
    margin-left: 10%;
  } */

  @media ${theme.device.medium} {
    object-fit: cover;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  justify-content: center;

  box-sizing: border-box;
  margin-left: 15%;
  padding: 0 20px;

  @media ${theme.device.large} {
    gap: 12px;
    align-items: flex-start;
    width: 70%;
    margin-left: 10%;
  }

  @media ${theme.device.medium} {
    gap: 12px;
    align-items: flex-start;

    width: 100%;
    height: auto;
    margin: 0 auto;
  }
`

const LogoBox = styled.div`
  display: flex;
  width: 60vw;

  @media ${theme.device.large} {
    align-items: flex-start;
  }

  @media ${theme.device.medium} {
    align-items: center;
  }
`

const Logo = styled.img`
  width: 60vw;
  max-width: 500px;
  height: 100px;
  object-fit: contain;

  @media ${theme.device.large} {
    width: 40vw;
  }

  @media ${theme.device.medium} {
    width: 80vw;
  }
`

const TitleBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media ${theme.device.large} {
    flex-direction: column;
    gap: 8px;
    align-items: start;
  }
`

const Title = styled.p`
  font-family: NanumSquareNeo-ExtraBold, sans-serif;
  font-size: 24px;
  font-weight: 700;

  @media ${theme.device.large} {
    font-size: 18px;
  }

  @media ${theme.device.large} {
    font-size: 18px;
  }
`

const CountdownBox = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  @media ${theme.device.large} {
    gap: 10px;
    width: 100%;
  }
`

const CountdownTimeCircle = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  aspect-ratio: 1/1;
  width: 146px;
  max-width: 146px;

  &::before {
    content: '';

    position: absolute;
    inset: 0;

    padding: 10px;

    background: linear-gradient(30deg, transparent, #fef6e4, #fde1a5);
    border-radius: 100%;

    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);

    mask-composite: xor;
    mask-composite: exclude;

    @media ${theme.device.large} {
      inset: none;
      aspect-ratio: 1/1;
      padding: 5px;
    }
  }

  @media ${theme.device.large} {
    aspect-ratio: 1/1;
    width: 50%;
  }
`

const CountdownTime = styled.div`
  font-family: Montserrat-Bold, sans-serif;
  font-size: 42px;
  font-weight: 700;

  @media ${theme.device.large} {
    font-size: 24px;
  }
`

const CountdownUnit = styled.div`
  font-family: Montserrat-Light, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 33.6px;
  text-align: center;

  @media ${theme.device.large} {
    font-size: 15px;
    line-height: 15px;
  }
`

// const ButtonBox = styled.div`
//   display: flex;
//   gap: 20px;

//   @media ${theme.device.large} {
//     flex-direction: column;
//     box-sizing: border-box;
//     width: 100%;
//     margin-bottom: 20px;
//   }
// `
